(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sweet-sleep-variant-options"] && !Shopify.designMode) return;
  try {
    function formatCurrency(valueInCents, currencyCode = 'USD', locale = 'en-US') {
    // Converte o valor de centavos para a unidade principal da moeda (ex: dólares, reais)
    const amount = Number(valueInCents) / 100;

    // Verifica se o valor é um número válido
    if (isNaN(amount)) {
      console.error('Valor inválido fornecido para formatCurrency:', valueInCents);
      return 'N/A'; // Ou pode retornar o valor original, ou uma string de erro
    }

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency', // Queremos formatar como moeda
        currency: currencyCode, // Especifica a moeda
        minimumFractionDigits: 2, // Garante sempre duas casas decimais
        maximumFractionDigits: 2, // Garante sempre duas casas decimais
      }).format(amount);
    } catch (error) {
      console.error('Erro ao formatar moeda:', error);
      // Fallback simples caso Intl.NumberFormat falhe (raro com locales e currencyCodes válidos)
      return `${currencyCode === 'USD' ? '$' : currencyCode + ' '}${amount.toFixed(2)}`;
    }
  }
  // Function to update the styles of product variants
  function updateProductVariantStyles() {
    const productVariantsElements = document.querySelectorAll('.product-variant'); // Renomeado para evitar conflito
    const selectedVariantsInputs = document.querySelectorAll('.product-variant:has(input[type="radio"]:checked)');

    // Certifique-se de que há seletores de variante suficientes (ex: tamanho e aroma)
    if (selectedVariantsInputs.length < 2) {
      // Ajuste este número com base em quantas opções você tem (ex: size, scent)
      // console.warn('Não há seletores de variante suficientes para determinar a variante completa.');
      // Você pode querer limpar a classe 'variant-selected' ou não fazer nada se a seleção não estiver completa.
      productVariantsElements.forEach((el) => el.classList.remove('variant-selected'));
      selectedVariantsInputs.forEach((el) => el.classList.add('variant-selected'));
      return; // Sai se não houver seleções suficientes para encontrar uma variante única.
    }

    const selectedSizeInput = selectedVariantsInputs[0].querySelector('input[type="radio"]:checked');
    const selectedScentInput = selectedVariantsInputs[1].querySelector('input[type="radio"]:checked');

    // Verifica se ambos os inputs foram encontrados e estão checados
    if (!selectedSizeInput || !selectedScentInput) {
      // console.warn('Um ou mais inputs de variante selecionados não foram encontrados.');
      return;
    }

    const selectedVariantOptions = { size: selectedSizeInput.value, scent: selectedScentInput.value };

    selectedVariantsInputs.forEach((variantElement) => {
      variantElement.classList.add('variant-selected');
    });

    // Remove a classe 'variant-selected' dos não selecionados explicitamente (se necessário)
    productVariantsElements.forEach((variantElement) => {
      if (
        !variantElement.classList.contains('variant-selected') &&
        !variantElement.querySelector('input[type="radio"]:checked')
      ) {
        // A lógica CSS :has(input:checked) já deve cuidar da borda,
        // mas esta classe pode ser para outros estilos.
      }
    });

    const variantsDataElement = document.getElementById('product-variants-json-data');
    if (variantsDataElement) {
      try {
        const variantsJsonString = variantsDataElement.textContent;
        const productVariantsData = JSON.parse(variantsJsonString); // Renomeado para evitar conflito

        if (productVariantsData && productVariantsData.length > 0) {
          const variantSelected = productVariantsData.find(
            (productVariant) =>
              productVariant.option1 === selectedVariantOptions.size &&
              productVariant.option2 === selectedVariantOptions.scent
          );

          if (variantSelected) {
            const subcriptionPlanId = document.querySelector('select[name="selling_plan"]')
              ? document.querySelector('select[name="selling_plan"]').value
              : null;

            const oneTimePriceSpan = document.getElementById('one-time-price');
            const originalPriceSpan = document.querySelector('.original-price');
            if (oneTimePriceSpan && originalPriceSpan) {
              const originalPrice = formatCurrency(variantSelected.price);
              originalPriceSpan.textContent = originalPrice;
              oneTimePriceSpan.textContent = originalPrice;
            }

            const currentPriceSpan = document.querySelector('.current-price');
            if (currentPriceSpan && subcriptionPlanId && variantSelected.selling_plan_allocations) {
              const allocation = variantSelected.selling_plan_allocations.find(
                (selling_plan) => selling_plan.selling_plan_id == subcriptionPlanId
              );
              if (allocation) {
                const currentPrice = formatCurrency(allocation.price);
                currentPriceSpan.textContent = currentPrice;
              }
            } else if (currentPriceSpan) {
              // Se não houver plano de assinatura ou não encontrado, mostrar preço original
              currentPriceSpan.textContent = formatCurrency(variantSelected.price);
            }

            const inputForm = document.querySelector('input[name="id"]');
            if (inputForm) {
              inputForm.setAttribute('value', variantSelected.id);
            }

            if (variantSelected.featured_media.id) {
              const mediaGalleryElement = document.querySelector('media-gallery[id^="MediaGallery-"]');

              if (mediaGalleryElement && typeof mediaGalleryElement.setActiveMedia === 'function') {
                // O ID da galeria é algo como "MediaGallery-{{ section.id }}"
                // O ID da mídia dentro da galeria é "{{ section.id }}-{{ media.id }}"
                const galleryFullId = mediaGalleryElement.id; // Ex: "MediaGallery-main-product"
                const gallerySectionId = galleryFullId.substring('MediaGallery-'.length);

                if (gallerySectionId) {
                  const targetMediaId = `${gallerySectionId}-${variantSelected.featured_media.id}`;
                  mediaGalleryElement.setActiveMedia(targetMediaId, true); // 'false' para prepend é o comum
                } else {
                  console.warn(
                    'Não foi possível determinar o ID da seção da galeria de mídia a partir do ID do elemento:',
                    galleryFullId
                  );
                }
              } else {
                console.warn('Elemento media-gallery ou método setActiveMedia não encontrado.');
              }
            }
          }
        }
      } catch (e) {
        console.error('Erro ao processar dados JSON das variantes:', e);
      }
    } else {
      console.error(
        'A tag <script> com os dados JSON das variantes não foi encontrada (ID: product-variants-json-data).'
      );
    }
  }

  const radioButtonsInVariants = document.querySelectorAll('.product-variant input[type="radio"]');
  radioButtonsInVariants.forEach((radio) => {
    radio.addEventListener('change', updateProductVariantStyles);
  });

  document.addEventListener('DOMContentLoaded', () => {
    // A chamada inicial pode precisar de lógica para garantir que todas as opções default estejam selecionadas
    // antes de tentar encontrar uma variante.
    if (document.querySelectorAll('.product-variant input[type="radio"]:checked').length >= 2) {
      // Ou o número de suas opções
      updateProductVariantStyles();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
